// Production domains determine the entry even after tab storage or user state is lost.
export function getRootPath () {
  return /^(www\.)?labelcheap\.com$/i.test(window.location.hostname) ? '/welcome' : '/home'
}

export function getLoginPath (role) {
  const hostname = window.location.hostname.toLowerCase()
  if (hostname === 'www.labelcheap.com' || hostname === 'labelcheap.com') return '/portal/sign-in'
  if (hostname === 'www.admin.labelcheap.com' || hostname === 'admin.labelcheap.com') return '/login'
  if (role) return role === 'ROLE_ADMIN' ? '/login' : '/portal/sign-in'
  if (window.location.pathname === '/portal/sign-in' || window.location.pathname === '/portal/login') return '/portal/sign-in'
  if (window.location.pathname === '/login') return '/login'
  try {
    return window.sessionStorage.getItem('loginTarget') === 'CUSTOMER' ? '/portal/sign-in' : '/login'
  } catch (error) {
    return '/login'
  }
}
